import { LeadQueueEffects } from 'src/app/lead-queue/store/effects/lead-queue.effects';

export const leadQueueEffects = [LeadQueueEffects];
